exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fc-event-container a{width:10px!important;background:var(--db--arrow-down-border);float:left}", ""]);

// exports
